import React from 'react'
import {connect} from 'react-redux'
import {Flex} from '/app/src/component'
import style from './style.css'
import UserModel from '/app/src/model/User/model'
import SystemModel from '/app/src/model/System/model'
import ConversationSelector from '/app/src/model/Conversation/selector'

class Item extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            hover: false
        }
        this._onMouseOver = this._onMouseOver.bind(this)
        this._onMouseOut = this._onMouseOut.bind(this)
        this._onMouseClick = this._onMouseClick.bind(this)
    }
    _onMouseOut(e){
        this.setState({hover: false})
    }
    _onMouseOver(e){
        const employee = this.props.employee
        const online = employee.is_online
        if(!online) return;

        this.setState({hover: true})
    }
    _onMouseClick(e){
        const employee = this.props.employee
        const online = employee.is_online
        const room = this.props.room
        if(!online) return;

        this.props.dispatch(UserModel.transferTicket(room, employee, this.props.customerDisplayName))
        this.props.dispatch(SystemModel.closeModal())
    }

    render(){
        const employee = this.props.employee
        const online = employee.is_online

        let url = employee.image_url
        if(!url)
            url = '/images/employee-avatar.png'

        let onlineStatus = 'Offline'
        if(online) onlineStatus = 'Online'

        let hoverStyle = {}
        if(this.state.hover) hoverStyle = {'backgroundColor': '#f4fdff'}


        return (
            <Flex
                key={employee.id} onMouseOut={this._onMouseOut} onMouseOver={this._onMouseOver} onClick={this._onMouseClick}
                style={hoverStyle} className={`${style.Item} ${style[onlineStatus]}`}
                hAlignContent='left' vAlignContent='center' basis='70px' width='100%'>
                <Flex className={style.ImgContainer} hAlignContent='left' paddingLeft='20px'>
                    <img src={url} alt='coworker'/>
                </Flex>
                <Flex hAlignContent='left' vAlignContent='center' grow
                >
                    <div style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}>
                    {employee.name}
                    </div>
                </Flex>
            </Flex>
        )
    }
}

function mapStateToProps(state, props) {
    const conversation = ConversationSelector.getByRoom(state, props.room);
    const customerName = ConversationSelector.getCustomerName(conversation, null)
    const customerId = ConversationSelector.getCompanyCustomerId(conversation, null)
    let customerDisplayName = '<ID saknas>'
    if (customerName) customerDisplayName = `"${customerName}"`
    else if (customerId) customerDisplayName = `besökare #${customerId}`
    return {
        customerDisplayName: customerDisplayName
    }
}

export default connect(mapStateToProps, null)(Item)



// WEBPACK FOOTER //
// ./src/layout/Dashboard/Modal/Transfer/Item.js